<div class="modal-header">
  <h4 class="modal-title pull-left">{{'admintool.importArticle.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner d-flex flex-column">
    <form class="m-1" novalidate [formGroup]="form">
      <div class="mb-3 row col-md-12">
        <label class="col-md-4 col-form-label">{{'admintool.importArticle.source' | translate}}</label>
        <select class="col-md-8 form-control item-dropdown" formControlName="source">
          <option *ngFor="let source of importArticleSources" [ngValue]="source">
            {{'admintool.importArticle.source.' + source | translate }}
          </option>
        </select>
      </div>

      <div *ngIf="form.get('source').value === ImportArticleSource.WX_DATABASE" class="mb-3 row col-md-12">
        <label class="col-md-4 col-form-label" for="articleIdOrNumber">{{'manageAccessories.source_article' | translate}}</label>
        <div class="col-md-8 p-0">
          <input class="form-control"
                 (keydown.enter)="importArticle()"
                 [class.is-invalid]="form.controls?.articleIdOrNumber?.touched && form.controls?.articleIdOrNumber?.invalid"
                 type='text'
                 formControlName="articleIdOrNumber"
                 autocomplete="off"
                 id="articleIdOrNumber">
          <div class="invalid-feedback">{{getInputError(form.get('articleIdOrNumber'))}}</div>
        </div>
      </div>

      <div class="mb-3 row col-md-12">
        <label class="col-md-4 col-form-label">{{'admintool.importArticle.importType' | translate}}</label>
        <select class="col-md-8 form-control item-dropdown" formControlName="importType">
          <option *ngFor="let type of importArticleTypes" [ngValue]="type" [hidden]="isImportArticleTypeDisabled(type)">
            {{'admintool.importArticle.importType.' + type | translate }}
          </option>
        </select>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button [disabled]="form.invalid" class="btn btn-primary" (click)="importArticle()">
    {{'global.label.continue' | translate}}
  </button>
</div>
